import { render, staticRenderFns } from "./AppTableV2.vue?vue&type=template&id=6945ce38&scoped=true"
import script from "./AppTableV2.vue?vue&type=script&lang=js"
export * from "./AppTableV2.vue?vue&type=script&lang=js"
import style0 from "./AppTableV2.vue?vue&type=style&index=0&id=6945ce38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6945ce38",
  null
  
)

export default component.exports